/** @flow */
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import Campaign from 'common/modules/campaign/domain/Campaign';
import CampaignMetrics from 'common/modules/campaign/domain/CampaignMetrics';
import { CardContent, CardTitle, CardWrapper, SCard } from 'common/modules/printing/styles/Card';
import { GraphWrapper } from 'common/modules/printing/styles/Graph';

import CumulativeCampaignMetricByDayLineChart from '../CumulativeCampaignMetricByDayLineChart';

type Props = {
  campaign: Campaign;
  metrics: CampaignMetrics;
  theme: any;
  t: any,
};

function ImpressionsDailyProgressionCard(props: Props) {
  const { campaign, t, theme } = props;

  const campaignDateRange = campaign.getFullDateRange(props.metrics);
  const { from, to } = campaignDateRange;

  const metrics = props.metrics.padMissingMetricsUntil(campaignDateRange);

  return (
    <SCard>
      <CardWrapper>
        <CardTitle>
          {t('impressions')}
        </CardTitle>
        <CardContent>
          <GraphWrapper flex={1}>
            <CumulativeCampaignMetricByDayLineChart
              primary={theme.colors.primary}
              secondary={theme.colors.darkPrimary}
              metricByDate={metrics.cumulativeImpressionsByDate}
              spotsByDate={metrics.spotsByDate}
              from={from}
              to={to}
              proposition={campaign.proposition}
            />
          </GraphWrapper>
        </CardContent>
      </CardWrapper>
    </SCard>
  );
}

export default withTheme(translate('commonSales')(ImpressionsDailyProgressionCard));



// WEBPACK FOOTER //
// ./src/common/modules/campaign/components/printing/ImpressionsDailyProgressionCard.js